// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M7.99984 14.6663V19.9997M23.9998 11.9997V17.333M22.6665 5.33301C25.9314 5.33301 27.6973 5.83269 28.576 6.22026C28.693 6.27188 28.7515 6.29769 28.9204 6.45884C29.0216 6.55543 29.2063 6.83887 29.2539 6.97046C29.3332 7.18999 29.3332 7.30999 29.3332 7.55V21.8812C29.3332 23.0929 29.3332 23.6987 29.1515 24.0101C28.9666 24.3269 28.7884 24.4742 28.4424 24.5959C28.1023 24.7156 27.4158 24.5837 26.0427 24.3199C25.0817 24.1352 23.9419 23.9997 22.6665 23.9997C18.6665 23.9997 14.6665 26.6663 9.33317 26.6663C6.06823 26.6663 4.30233 26.1667 3.42368 25.7791C3.30667 25.7275 3.24816 25.7017 3.0793 25.5405C2.97809 25.4439 2.79333 25.1605 2.7458 25.0289C2.6665 24.8094 2.6665 24.6894 2.6665 24.4493L2.6665 10.1181C2.6665 8.90646 2.6665 8.30061 2.84821 7.9892C3.03304 7.67243 3.21129 7.52516 3.55725 7.40342C3.89735 7.28374 4.58388 7.41565 5.95694 7.67947C6.91799 7.86413 8.05781 7.99967 9.33317 7.99967C13.3332 7.99967 17.3332 5.33301 22.6665 5.33301ZM19.3332 15.9997C19.3332 17.8406 17.8408 19.333 15.9998 19.333C14.1589 19.333 12.6665 17.8406 12.6665 15.9997C12.6665 14.1587 14.1589 12.6663 15.9998 12.6663C17.8408 12.6663 19.3332 14.1587 19.3332 15.9997Z"
    />
  </svg>
);
const IconMoneyNote = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconMoneyNote;
